import { Component, HostListener, OnDestroy, OnInit, input, output } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PaymentSummary, SERVICE_FEE_HINT, formatEuro } from '../../payments.models';

@Component({
  selector: 'app-payment-summary',
  imports: [MatTooltipModule],
  templateUrl: './payment-summary.component.html',
  styleUrl: './payment-summary.component.scss',
})
export class PaymentSummaryComponent implements OnInit, OnDestroy {
  readonly summary = input.required<PaymentSummary>();

  readonly closed = output<void>();
  readonly pay = output<void>();

  readonly serviceFeeHint = SERVICE_FEE_HINT;

  private previousBodyOverflow = '';

  ngOnInit(): void {
    this.previousBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }

  ngOnDestroy(): void {
    document.body.style.overflow = this.previousBodyOverflow;
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.closed.emit();
  }

  formatEuro(cents: number): string {
    return formatEuro(cents);
  }
}
